import i18n from "../i18n";

const lcaDropdownCache = new Map();

export function applyLcaDropdownCache(key, setData) {
  if (!key || !lcaDropdownCache.has(key)) return false;
  setData(lcaDropdownCache.get(key));
  return true;
}

export function writeLcaDropdownCache(key, data) {
  if (key) lcaDropdownCache.set(key, data);
}

export function lcaCacheKeyGlobal(endpointId) {
  return `_g::${endpointId}`;
}

export function lcaCacheKeyGlobalI18n(endpointId) {
  const lang = i18n.language || "en";
  return `_g::${lang}::${endpointId}`;
}

export function lcaCacheKeyProduct(productId, endpointId) {
  if (productId == null || productId === "") return null;
  return `p::${productId}::${endpointId}`;
}

export function lcaCacheKeyTransportPackaging(flow) {
  return `_g::transport-packaging::${flow}`;
}

export function clearLcaProductDropdownCache(productId) {
  if (productId == null || productId === "") return;
  const prefix = `p::${productId}::`;
  for (const k of [...lcaDropdownCache.keys()]) {
    if (k.startsWith(prefix)) lcaDropdownCache.delete(k);
  }
}
